import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    buildRoutes: translate({ id: 'rm.sidebar.buildRoutes' }),
    instantBuild: translate({ id: 'rm.sidebar.buildRoutes.instantBuild' }),
    defaultLabel: translate({ id: 'rm.sidebar.buildRoutes.default' }),
    customBuild: translate({ id: 'rm.sidebar.buildRoutes.customBuild' }),
  }))

  return api
}
